import { FieldInputProps } from 'react-final-form'

/**
 * @description return the correct formated value
 */
export const renderValue = (input: FieldInputProps<string, HTMLElement>): string => {
  if (!input.value || input.valie === null) {
    return ''
  }
  return input.value.substr(1)
}
